import {
	createContext,
	Dispatch,
	ReactNode,
	SetStateAction,
	useContext,
	useState,
} from "react";
import { CustomBoxesFormType } from "../CustomBoxesForm/CustomBoxesForm.client";

type ConfirmationContextType = {
	orderInfo: CustomBoxesFormType | null;
	setOrderInfo: Dispatch<SetStateAction<CustomBoxesFormType | null>>;
};
const ConfirmationContext = createContext({} as ConfirmationContextType);

export const useConfirmation = () => useContext(ConfirmationContext);

type Props = {
	children: ReactNode;
};
const ConfirmationProvider = ({ children }: Props) => {
	const [orderInfo, setOrderInfo] = useState<CustomBoxesFormType | null>(
		null
	);

	return (
		<ConfirmationContext.Provider value={{ orderInfo, setOrderInfo }}>
			{children}
		</ConfirmationContext.Provider>
	);
};
export default ConfirmationProvider;
